import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.replace("https://studygri.com/en");
  }, []);
  return null;
}

export default App;
